import i18next from "i18next";
import { toast } from "react-toastify";

import { custom, failure } from "./utilities";
import { reelsServices } from "../../services";
import { globalSystemConstants, reelsConstants } from "../../constants";
import { customToast, getFilterExpression, errorHandler } from "../../shared";

const {
  ADD_REEL_TYPE,
  GET_REEL_DETAILS,
  UPDATE_REEL_TYPE,
  UPDATE_RECAP_TYPE,
  ASSIGN_REEL_EVENT,
  GET_RECAP_FEEDBACK,
  GET_REEL_TYPE_BY_ID,
  GET_REELS_BY_EVENT_ID,
  GET_REEL_TYPE_DETAILS,
  GET_RECAP_TYPE_DETAILS,
  GET_ASSIGNED_REEL_EVENTS,
  GET_UNASSIGNED_REEL_EVENTS,
  GET_REELS_BY_EVENT_GROUP_ID,
  REMOVE_ASSIGNED_REEL_SHUTTERB,
  RECAP_STATUS,
} = reelsConstants;

const getUnassignedReelEvents = () => {
  return (dispatch) => {
    dispatch(
      custom(GET_UNASSIGNED_REEL_EVENTS, globalSystemConstants.SPINNER_ACTIVATE)
    );
    reelsServices
      .getUnassignedReelEvents()
      .then(
        (response) => {
          dispatch(custom(response, GET_UNASSIGNED_REEL_EVENTS));
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, GET_UNASSIGNED_REEL_EVENTS));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_UNASSIGNED_REEL_EVENTS,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const getAssignedReelEvents = (
  pageSize = reelsConstants.DEFAULT_PAGINATION_PAGE_SIZE,
  pageIndex = 1,
  status = RECAP_STATUS.PENDING,
  filterExpression = getFilterExpression(""),
  orderBy
) => {
  return (dispatch) => {
    dispatch(
      custom(GET_ASSIGNED_REEL_EVENTS, globalSystemConstants.SPINNER_ACTIVATE)
    );
    reelsServices
      .getAssignedReelEvents(
        pageSize,
        pageIndex,
        status,
        filterExpression,
        orderBy
      )
      .then(
        (response) => {
          dispatch(custom(response, GET_ASSIGNED_REEL_EVENTS));
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, GET_ASSIGNED_REEL_EVENTS));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_ASSIGNED_REEL_EVENTS,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const assignReelEventToShutterb = (data) => {
  return (dispatch) => {
    dispatch(custom(ASSIGN_REEL_EVENT, globalSystemConstants.SPINNER_ACTIVATE));
    reelsServices
      .assignReelEventToShutterb(data)
      .then(
        (response) => {
          customToast(i18next.t("assigned_successfully"), toast.TYPE.SUCCESS);
          dispatch(getAssignedReelEvents());
          dispatch(getUnassignedReelEvents());
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, ASSIGN_REEL_EVENT));
        }
      )
      .finally(() => {
        dispatch(
          custom(ASSIGN_REEL_EVENT, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const removeAssignedReelShutterb = (
  id,
  pageSize,
  pageNumber,
  filterExpression
) => {
  return (dispatch) => {
    dispatch(
      custom(
        REMOVE_ASSIGNED_REEL_SHUTTERB,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    reelsServices
      .removeAssignedReelShutterb(id)
      .then(
        (response) => {
          customToast(i18next.t("removed_successfully"), toast.TYPE.SUCCESS);
          dispatch(
            getAssignedReelEvents(pageSize, pageNumber, filterExpression)
          );
          dispatch(getUnassignedReelEvents());
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, REMOVE_ASSIGNED_REEL_SHUTTERB));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            REMOVE_ASSIGNED_REEL_SHUTTERB,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const getReelDetails = (reelId) => {
  return (dispatch) => {
    dispatch(custom(GET_REEL_DETAILS, globalSystemConstants.SPINNER_ACTIVATE));
    reelsServices
      .getReelDetails(reelId)
      .then(
        (response) => {
          // in case of reel
          dispatch(custom(response, GET_REEL_DETAILS));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_REEL_DETAILS, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const getReelTypes = () => {
  return (dispatch) => {
    dispatch(
      custom(GET_REEL_TYPE_DETAILS, globalSystemConstants.SPINNER_ACTIVATE)
    );
    reelsServices
      .getReelTypes()
      .then(
        (response) => {
          // in case of reel
          dispatch(custom(response, GET_REEL_TYPE_DETAILS));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_REEL_TYPE_DETAILS,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const getReelTypeById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(GET_REEL_TYPE_BY_ID, globalSystemConstants.SPINNER_ACTIVATE)
    );
    reelsServices
      .getReelTypeById(id)
      .then(
        (response) => {
          // in case of reel
          dispatch(custom(response, GET_REEL_TYPE_BY_ID));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_REEL_TYPE_BY_ID, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const addReelType = (data) => {
  return (dispatch) => {
    dispatch(custom(ADD_REEL_TYPE, globalSystemConstants.SPINNER_ACTIVATE));
    reelsServices
      .addReelType(data)
      .then(
        (response) => {
          customToast(i18next.t("done_successfully"), toast.TYPE.SUCCESS);
          dispatch(getReelTypes());
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(ADD_REEL_TYPE, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const getRecapTypes = () => {
  return (dispatch) => {
    dispatch(
      custom(GET_RECAP_TYPE_DETAILS, globalSystemConstants.SPINNER_ACTIVATE)
    );
    reelsServices
      .getRecapTypes()
      .then(
        (response) => {
          dispatch(custom(response, GET_RECAP_TYPE_DETAILS));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_RECAP_TYPE_DETAILS,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const updateRecapType = (data) => {
  return (dispatch) => {
    dispatch(custom(UPDATE_RECAP_TYPE, globalSystemConstants.SPINNER_ACTIVATE));
    reelsServices
      .updateRecapType(data)
      .then(
        (response) => {
          customToast(i18next.t("done_successfully"), toast.TYPE.SUCCESS);
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(getRecapTypes());
        dispatch(
          custom(UPDATE_RECAP_TYPE, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const updateReelType = (data) => {
  return (dispatch) => {
    dispatch(custom(UPDATE_REEL_TYPE, globalSystemConstants.SPINNER_ACTIVATE));
    reelsServices
      .updateReelType(data)
      .then(
        (response) => {
          getReelTypes();
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(UPDATE_REEL_TYPE, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const removeReelType = (id) => {
  return (dispatch) => {
    dispatch(custom(UPDATE_REEL_TYPE, globalSystemConstants.SPINNER_ACTIVATE));
    reelsServices
      .removeReelType(id)
      .then(
        (response) => {
          customToast(i18next.t("remove_successfully"), toast.TYPE.SUCCESS);
          dispatch(getReelTypes());
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(UPDATE_REEL_TYPE, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const getRecapFeedback = (pageSize, pageNumber, status) => {
  return (dispatch) => {
    dispatch(
      custom(GET_RECAP_FEEDBACK, globalSystemConstants.SPINNER_ACTIVATE)
    );
    reelsServices
      .getRecapFeedback(pageSize, pageNumber, status)
      .then(
        (response) => {
          dispatch(custom(response, GET_RECAP_FEEDBACK));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_RECAP_FEEDBACK, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const getReelsByEventId = (eventId) => {
  return (dispatch) => {
    dispatch(
      custom(GET_REELS_BY_EVENT_ID, globalSystemConstants.SPINNER_ACTIVATE)
    );
    reelsServices
      .getReelsByEventId(eventId)
      .then(
        (response) => {
          // in case of reel
          dispatch(custom(response, GET_REELS_BY_EVENT_ID));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_REELS_BY_EVENT_ID,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const getReelsByEventGroupId = (eventGroupId) => {
  return (dispatch) => {
    dispatch(
      custom(
        GET_REELS_BY_EVENT_GROUP_ID,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    reelsServices
      .getReelsByEventGroupId(eventGroupId)
      .then(
        (response) => {
          dispatch(custom(response, GET_REELS_BY_EVENT_GROUP_ID));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_REELS_BY_EVENT_GROUP_ID,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

export const reelsActions = {
  getAssignedReelEvents,
  getUnassignedReelEvents,
  assignReelEventToShutterb,
  removeAssignedReelShutterb,
  getReelDetails,
  getReelTypes,
  getRecapTypes,
  getReelTypeById,
  addReelType,
  updateReelType,
  removeReelType,
  updateRecapType,
  getRecapFeedback,
  getReelsByEventId,
  getReelsByEventGroupId,
};
